import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { formatDate } from "../../../../utils/utils";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import ContentLayout from "../../../../partials/content/ContentLayout";
import { PageSubHeader } from "../../../../../provider/PageDataProvider";
import {
  cancelDeliveryOrder,
  getSoDeliveries,
} from "../../../../services/sales/salesDeliveryService";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { Badge } from "react-bootstrap";

function DeliveryOrderList({ history }) {
  const [deliveries, setDeliveries] = useState([]);
  const { reload } = useGlobalData();
  const deliveryDetailColumn = [
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  const getSoDeliveriesData = async () => {
    const response = await getSoDeliveries();
    const { data } = response.data;
    setDeliveries(data.soDeliveries);
  };

  useEffect(() => {
    getSoDeliveriesData();
  }, [reload]);

  return (
    <React.Fragment>
      <PageSubHeader
        title="Delivery Order"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/sales/deliveyr-order",
            title: "Delivery Order List",
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/menu");
            },
          },
          {
            title: "New Delivery",
            color: "primary",
            icon: "fas fa-plus-circle",
            onClick: () => {
              history.push("/sales/delivery-order-form");
            },
          },
        ]}
      />
      <ContentLayout>
        <CustomDataTable
          data={deliveries}
          dataDetailColumns={deliveryDetailColumn}
          onRefreshData={() => {}}
          columns={[
            {
              header: "Delivery ID",
              field: "ID",
              body: null,
              sortable: true,
              filter: true,
            },
            {
              header: "Delivery Date",
              field: "deliveryDate",
              body: (rowData) => formatDate(rowData.deliveryDate),
              sortable: true,
              filter: true,
            },
            {
              header: "Status",
              field: "delivery.ID",
              body: (rowData) => {
                if (rowData.delivery.ID > 0) {
                  return <Badge variant="success">Delivered</Badge>;
                } else {
                  return <Badge variant="danger">Not Delivered</Badge>;
                }
              },
              sortable: true,
              filter: true,
            },
            {
              header: "Document Reference",
              field: "deliveryDocRef",
              body: null,
              sortable: true,
              filter: true,
            },
            {
              header: "Document Reference ID",
              body: (rowData) => (
                <React.Fragment>{rowData.salesOrderCode}</React.Fragment>
              ),
              sortable: false,
              filter: false,
            },
            {
              header: "Customer Name",
              field: "customer.customerName",
              body: (rowData) => (
                <React.Fragment>
                  <ResponsiveEllipsis
                    text={rowData.customer.customerName}
                    maxLine="1"
                  />
                </React.Fragment>
              ),
              sortable: true,
              filter: true,
            },

            {
              header: "Actions",
              body: (rowData) => (
                <React.Fragment>
                  <BootstrapTooltip title="Edit Delivery Ordser">
                    <button
                      type="button"
                      onClick={() => {
                        history.push(
                          "/sales/edit-delivery-order/" + rowData.ID
                        );
                      }}
                      className="btn btn-icon btn-label-primary btn-circle btn-md mx-1"
                    >
                      <i className="fas fa-edit"></i>
                    </button>
                  </BootstrapTooltip>
                  <BootstrapTooltip title="Delete Delivery Order Detail">
                    <button
                      type="button"
                      className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                      onClick={() => {
                        cancelDeliveryData(rowData.ID);
                      }}
                    >
                      <i className="fas fa-trash-alt"></i>
                    </button>
                  </BootstrapTooltip>
                </React.Fragment>
              ),
              sortable: false,
            },
          ]}
        />
      </ContentLayout>
    </React.Fragment>
  );

  async function cancelDeliveryData(deliveryID = 0) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Delivery ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          cancelDeliveryOrder(deliveryID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            history.push("/sales/delivery-order");
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }
}

export default DeliveryOrderList;
